'use strict';

angular.module('SelectableDropdown', []);
